<template>
  <div class="works-filter">
    <div class="works-filter__blocks">
      <!--
      вид искуства
      сюжет
      стиль
      техника
      период
      стоимость
      размер-->

      <filter-arttype label_class="works-filter__label"/>
      <filter-genre-sub label_class="works-filter__labels" :is_all_on_top="true"/>
      <filter-style-sub label_class="works-filter__labels" :is_all_on_top="true"/>
      <filter-technique-sub label_class="works-filter__labels" :is_all_on_top="true"/>
      <filter-period-sub title_class="works-filter__block-item works-filter__block-title" label_class="works-filter__labels"/>
      <filter-color title_class="works-filter__block-item works-filter__block-title" :is_show="false" @updated="childupdated"/>
      <filter-price-sub/>
      <filter-size title_class="works-filter__block-item works-filter__block-title" label_class="works-filter__labels"/>
      <filter-pl-region-sub/>
      <filter-region-sub :is_show="false" @updated="childupdated"/>
      <filter-author-sub v-if="to_gallery_id>0" :is_show="false" @updated="childupdated"/>
      <filter-place :is_show="false" @updated="childupdated" label_class="works-filter__labels" :is_all_on_top="true" :max_visible="100500"/>

      <div class="works-filter__block works-filter__block-advanced-filter">
        <a class="works-filter__block-title works-filter__block-hide" v-on:click="toggleFilters" :class="{ active: advanced }">
          <span class="item-text">{{ advanced? $t("message.AdvancedFilter") : $t("message.ToggleFilter") }}</span>
          <span class="icon-angle-down">
            <img src="/res/subdomains/img/light/filter-arrow.svg" alt="img/header-item__arrow.svg"/>
          </span>
        </a>
      </div>
    </div>
  </div>
</template>


<script>
  import FilterArttype from "../../../../components/list/filter/FilterArttype";
  import FilterGenre from "../../../../components/list/filter/FilterGenre";
  import FilterStyle from "../../../../components/list/filter/FilterStyle";
  import FilterTechnique from "../../../../components/list/filter/FilterTechnique";
  import FilterColor from "../../../../components/list/filter/FilterColor";
  import FilterPriceSub from "./filter/FilterPriceSub";
  import FilterSize from "../../../../components/list/filter/FilterSize";
  import FilterRegionSub from "./filter/FilterRegionSub";
  import FilterPlRegionSub from "./filter/FilterPlRegionSub";
  import FilterPlace from "../../../../components/list/filter/FilterPlace";

  import WorksFilterMix from "../../../../components/list/WorksFilterMix";
  import FilterGenreSub from "./filter/FilterGenreSub";
  import FilterStyleSub from "./filter/FilterStyleSub";
  import FilterTechniqueSub from "./filter/FilterTechniqueSub";
  import FilterPeriodSub from "./filter/FilterPeriodSub";
  import FilterAuthorSub from "./filter/FilterAuthorSub";

  export default {
    components: {
      FilterPlRegionSub,
      FilterPeriodSub,
      FilterTechniqueSub,
      FilterStyleSub,
      FilterGenreSub,
      FilterArttype, FilterGenre, FilterStyle, FilterTechnique,
      FilterColor, FilterPriceSub, FilterSize,
      FilterRegionSub, FilterPlace, FilterAuthorSub,
    },
    name      : 'works-filter-sub',
    data() {
      return {
        to_gallery_id: $('#app-wrapper').attr('gallery_id'),
      }
    },
    mixins: [WorksFilterMix],
  }
</script>



// WEBPACK FOOTER //
// src/sub/air_light/components/list/WorksFilterSub.vue